/*jslint browser */
/*global process */

var $ = jQuery;
declare var document: any;

/**
 *
 */
export default class Loader
{
    /**
     *
     */
    public load(): void {
        this.loadLibraries();
    }

    /**
     *
     * @private
     */
    private loadLibraries(): void {
        //$( ".datepicker" ).datepicker();
    }
}